export enum ActionType {
  PROGRESSION,
  QUALITY,
  CP_RECOVERY,
  BUFF,
  SPECIALTY,
  REPAIR,
  OTHER
}
